// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"707":"85466a8b","906":"56ccbe54"}[chunkId] + ".js";
};